import { render, staticRenderFns } from "./Call-History.vue?vue&type=template&id=feeea838&scoped=true&"
import script from "./Call-History.vue?vue&type=script&lang=js&"
export * from "./Call-History.vue?vue&type=script&lang=js&"
import style0 from "./Call-History.vue?vue&type=style&index=0&id=feeea838&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feeea838",
  null
  
)

export default component.exports